var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntiInfectives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.35 7.9L8.46001 46.7933C5.24821 50.0893 3.46401 54.5178 3.49377 59.1198C3.52354 63.7218 5.36488 68.1268 8.61904 71.381C11.8732 74.6351 16.2782 76.4765 20.8802 76.5062C25.4822 76.536 29.9107 74.7518 33.2067 71.54L72.1 32.6667C75.3843 29.3846 77.2302 24.9323 77.2318 20.2892C77.2334 15.6461 75.3904 11.1926 72.1083 7.90834C68.8263 4.62407 64.374 2.77811 59.7309 2.77655C55.0878 2.77499 50.6343 4.61795 47.35 7.9Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8867 53.8633L26.1367 29.1133",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6667 16.74C53.3629 16.0431 54.1896 15.4903 55.0996 15.1132C56.0096 14.736 56.9849 14.5419 57.97 14.5419C58.955 14.5419 59.9304 14.736 60.8404 15.1132C61.7504 15.4903 62.5771 16.0431 63.2733 16.74",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiInfectives);
export default __webpack_public_path__ + "static/media/anti-infectives.9d7826f474bf7ab9c2d97a7a7330a594.svg";
export { ForwardRef as ReactComponent };